module.exports = __webpack_public_path__ + "img/xanter-blanco.fb58d475.svg";